var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pano-hover-element"},[_vm._t("hoverElement"),_vm._t("dotElement")],2)}
var staticRenderFns = []

export { render, staticRenderFns }